import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import {isAuthenticated, isAuthorizedSiteAdmin} from 'components/utils/Session';
function AuthorizedRoute({ component: Component, ...rest }) {
    return (
        <Route
        {...rest}
        render={props =>
            isAuthenticated() && isAuthorizedSiteAdmin() ? (
                <Component {...props} />
            ) : (
            <Redirect
                to={{
                    pathname: "/accounts"
                }}
            />
            )
        }
        />
    );
}
export default AuthorizedRoute;